<main>
    <app-banner></app-banner>
    <app-about></app-about>
    <app-jobs></app-jobs>
    <app-skills></app-skills>
    <app-proyects></app-proyects>
    <app-contact></app-contact>
</main>

